import { render } from "./OfferAppointment.vue?vue&type=template&id=49bd0ed3"
import script from "./OfferAppointment.vue?vue&type=script&lang=ts"
export * from "./OfferAppointment.vue?vue&type=script&lang=ts"
script.render = render

export default script